<template>
  <div class="doc">
    <yu-head/>
    <div class="container">
      <yu-menu/>
      <yu-article>
        <div class="phone">

          <iframe src="http://mobileweb.yurencloud.com/#/button" width="320" height="580"></iframe>
        </div>
        <div class="title">按钮</div>

        <div class="sub-title">屏宽按钮</div>
        <pre v-highlightjs="code8"><code class="html" ></code></pre>

        <div class="sub-title">基础用法</div>
        <pre v-highlightjs="code1"><code class="html" ></code></pre>

        <div class="sub-title">图标按钮</div>
        <pre v-highlightjs="code2"><code class="html" ></code></pre>

        <div class="sub-title">按钮组</div>
        <pre v-highlightjs="code3"><code class="html" ></code></pre>

        <div class="sub-title">禁用状态</div>
        <pre v-highlightjs="code4"><code class="html" ></code></pre>


        <div class="sub-title">加载中</div>
        <pre v-highlightjs="code5"><code class="html" ></code></pre>

        <div class="sub-title">不同尺寸</div>
        <pre v-highlightjs="code6"><code class="html" ></code></pre>

        <div class="sub-title">圆形按钮</div>
        <pre v-highlightjs="code7"><code class="html" ></code></pre>


        <div class="sub-title">属性</div>
        <yu-table :data="attributes1" :widths="widths1"/>

        <div class="sub-title">事件</div>
        <yu-table :data="attributes2" :widths="widths2"/>

      </yu-article>
    </div>
  </div>
</template>

<script>
import { YuTable } from 'yu.ui';
import { YuButton, YuText } from 'yu.mobile';
import YuHead from './yu-head';
import YuMenu from './yu-menu';
import YuArticle from './yu-article';

export default {
  name: 'Buttons',
  data() {
    return {
      code1: `
  <yu-button>默认按钮</yu-button>
  <yu-button type="primary">主要按钮</yu-button>
  <yu-button type="success">成功按钮</yu-button>
  <yu-button type="warming">警告按钮</yu-button>
  <yu-button type="danger">危险按钮</yu-button>
  <yu-button type="info">信息按钮</yu-button>
  <br/>
  <yu-button plain>朴素按钮</yu-button>
  <yu-button type="primary" plain>主要按钮</yu-button>
  <yu-button type="success" plain>成功按钮</yu-button>
  <yu-button type="warming" plain>警告按钮</yu-button>
  <yu-button type="danger" plain>危险按钮</yu-button>
  <yu-button type="info" plain>信息按钮</yu-button>
      `,
      code2: `
  <yu-button icon="icon-edit" type="primary"/>
  <yu-button icon="icon-accessory" type="primary"/>
  <yu-button icon="icon-trash" type="primary"/>
  <yu-button icon="icon-search-o" type="primary">搜索</yu-button>
  <yu-button icon="icon-upload" type="primary">上传</yu-button>
      `,
      code3: `
  <yu-buttons>
    <yu-button type="primary">
      <i class="iconfont icon-angle-left"></i>
      上一页
    </yu-button>
    <yu-button type="primary">
      下一页
      <i class="iconfont icon-angle-right"></i>
    </yu-button>
  </yu-buttons>
  <yu-buttons>
    <yu-button icon="icon-edit" type="primary"/>
    <yu-button icon="icon-accessory" type="primary"/>
    <yu-button icon="icon-trash" type="primary"/>
  </yu-buttons>
      `,
      code4: `
  <div class="sub-title">禁用状态</div>
  <yu-button disabled>默认按钮</yu-button>
  <yu-button type="primary" disabled>主要按钮</yu-button>
  <yu-button type="success" disabled>成功按钮</yu-button>
  <yu-button type="warming" disabled>警告按钮</yu-button>
  <yu-button type="danger" disabled>危险按钮</yu-button>
  <yu-button type="info" disabled>信息按钮</yu-button>
  <br/>
  <yu-button plain disabled>朴素按钮</yu-button>
  <yu-button type="primary" plain disabled>主要按钮</yu-button>
  <yu-button type="success" plain disabled>成功按钮</yu-button>
  <yu-button type="warming" plain disabled>警告按钮</yu-button>
  <yu-button type="danger" plain disabled>危险按钮</yu-button>
  <yu-button type="info" plain disabled>信息按钮</yu-button>
      `,
      code5: `
  <yu-button loading type="primary">按钮</yu-button>
      `,
      code6: `
  <yu-button type="primary">正常按钮</yu-button>
  <yu-button type="primary" size="medium">中等按钮</yu-button>
  <yu-button type="primary" size="small">小型按钮</yu-button>
  <yu-button type="primary" size="mini">超小按钮</yu-button>
      `,
      code7: `
  <yu-button shape="circle" icon="icon-user"/>
  <yu-button shape="circle" icon="icon-user" size="medium"/>
  <yu-button shape="circle" icon="icon-user" size="small"/>
  <yu-button shape="circle" icon="icon-user" size="mini"/>
      `,
      code8: `
  <yu-button fluid>默认按钮</yu-button>
  <yu-button type="primary" fluid>主要按钮</yu-button>
      `,
      attributes1: [
        {
          prop: '参数',
          description: '说明',
          types: '类型',
          default: '默认值',
        },
        {
          prop: 'fluid',
          description: '宽度100%',
          types: 'Boolean',
          default: '无',
        },
        {
          prop: 'icon',
          description: '图标class',
          types: 'String',
          default: '无',
        },
        {
          prop: 'disabled',
          description: '禁用按钮',
          types: 'Boolean',
          default: '无',
        },
        {
          prop: 'shape',
          description: '按钮形状[circle]',
          types: 'Boolean',
          default: '无',
        },
        {
          prop: 'loading',
          description: '显示加载图标',
          types: 'Boolean',
          default: '无',
        },
        {
          prop: 'autofocus',
          description: '显示为激活按钮',
          types: 'Boolean',
          default: '无',
        },
        {
          prop: 'plain',
          description: '朴素按钮',
          types: 'Boolean',
          default: '无',
        },
        {
          prop: 'type',
          description: '按钮类型[default,primary,danger,warming,info,success]',
          types: 'String',
          default: '无',
        },
        {
          prop: 'size',
          description: '按钮大小[medium,small,mini]',
          types: 'String',
          default: '无',
        },
        {
          prop: 'nativeType',
          description: '按钮标签类型',
          types: 'String',
          default: 'button',
        },
        {
          prop: 'submit',
          description: '提交表单按钮,会触发yu-form的提交',
          types: 'Boolean',
          default: '无',
        },
      ],
      attributes2: [
        {
          event: '事件名称',
          description: '说明',
          callback: '回调参数',
        },
        {
          event: 'click',
          description: '触发按钮点击事件',
          callback: '( event: Event )',
        },
      ],
      widths1: {
        prop: '150px',
        description: '300px',
        types: '120px',
        default: '200px',
      },
      widths2: {
        event: '150px',
        description: '300px',
        callback: '320px',
      },
    };
  },
  components: {
    YuHead,
    YuMenu,
    YuArticle,
    YuButton,
    YuTable,
  },

};
</script>

<style lang="scss" scoped type="text/scss">
  @import "../assets/css/varible";

  .doc {
    color: $text;
    height: 100%;
    .container {
      width: 1200px;
      margin: 30px auto;
      .title {
        color: $text;
        font-weight: bold;
        padding: 14px 0;
        margin: 20px 0;
        border-bottom: 1px solid $border;
      }
      .sub-title {
        color: $text;
        padding: 0 8px;
        margin: 20px 0;
        border-left: 4px solid $primary;
      }
    }

    .phone {
      text-align: center;
      iframe {
        margin: 20px auto;
        border-radius: 20px;
        &::-webkit-scrollbar {
          width: 0;
        }
        border: 10px solid $border;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/buttons.vue